import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import {
  postQuestionTypes,
  getQuestionTypes,
  deleteQuestionType,
  updateQuestionTypes,
} from "../../_redux/actions/ActionQuestions";
import { connect } from "react-redux";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";

const AddQuestionType = ({
  postQuestionTypes,
  getQuestionTypes,
  questionTypes,
  deleteQuestionType,
  showAddType,
  setShowAddType,
  updateQuestionTypes,
}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    getQuestionTypes();
  }, [getQuestionTypes]);

  const { register, handleSubmit, reset, setValue } = useForm({
    mode: "onBlur",
    defaultValues: {},
  });

  const onSubmit = (formData) => {
    if (data) {
      updateQuestionTypes(formData, data.id);
      setData(null);
      reset();
    } else {
      postQuestionTypes(formData);
      reset();
      setShowAddType(false);
    }
  };
  return (
    <Card>
      <Card.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col md={4}>
              <Form.Group controlId="formGroupName">
                <Form.Label>Question Type</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    {...register("question_type")}
                    placeholder="eg:Career"
                  />
                  {data && (
                    <AiOutlineClose
                      className="position-absolute "
                      size={18}
                      style={{
                        top: "50%",
                        right: "8px",
                        transform: "translate(0,-50%)",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setData(null);
                        setValue("question_type", "");
                      }}
                    />
                  )}
                </div>
              </Form.Group>
              <Form.Group controlId="formGroupName">
                <Form.Label>Upload Image</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/png, image/jpeg"
                  {...register("images")}
                />
              </Form.Group>
            </Col>
            <Col md={8}>
              <div className="scroll-wrapper">
                <Row>
                  {questionTypes.length > 0 &&
                    questionTypes.map((item, index) => (
                      <Col md={6}>
                        <div className="question-type-list d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <img
                              src={
                                item.images
                                  ? item.images
                                  : `/assets/images/noimage.jpg`
                              }
                              alt=""
                              className="no-img mr-2"
                            />
                            <p>{item.question_type}</p>
                          </div>
                          <div>
                            <FaEdit
                              className="text-info pointer mr-1"
                              onClick={() => {
                                setValue("question_type", item.question_type);
                                setData(item);
                              }}
                            />

                            <FaTrashAlt
                              color="#BC2A20"
                              size={14}
                              className="pointer"
                              onClick={() => deleteQuestionType(item.id)}
                            />
                          </div>
                        </div>
                      </Col>
                    ))}
                </Row>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={2}>
              <Button className="btn-primary btn-round btn-sm" type="submit">
                {data ? "Edit" : "Add"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  questionTypes: state.questionTemplate.questionTypes,
});

const mapDispatchToProps = {
  postQuestionTypes,
  getQuestionTypes,
  deleteQuestionType,
  updateQuestionTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddQuestionType);
